import { Component, OnInit, Input, ViewChild, Output, EventEmitter, forwardRef, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'artemis-multiple-values-input',
  templateUrl: './multiple-values-input.component.html',
  styleUrls: ['./multiple-values-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultipleValuesInputComponent),
    multi: true
  }]
})
export class MultipleValuesInputComponent implements OnInit, ControlValueAccessor {


  @ViewChild(MatPaginator, {static: false}) set paginatorContent(paginator: MatPaginator) {
    this.dataSource.paginator = paginator;
  }

  @Input() name: string = '';
  @Input()
  set inputValues(values: Array<string> ) {
    this.values = values || [];
    if (this.values.length > 0) {
      this.dataSource.data = this.values;
      // this.formSubmitted.emit(this.values);
    } else {
      this.dataSource.data = [];
    }
  }
  @Output() formSubmitted: EventEmitter<Array<string>> = new EventEmitter();

  readonly displayedColumns: Array<string> = ['name', 'actions'];

  form: FormGroup;
  values: Array<string> = [];
  dataSource: MatTableDataSource<String> = new MatTableDataSource<String>(this.values);
  disabled: boolean = false;

  onChange: (data: any) => void;
  onTouched: () => void;

  constructor(private formBuilder: FormBuilder,
              private el: ElementRef) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      value: []
    });
  }

  changeValueInput(value: string): void {
    if (!value) {
      this.formSubmitted.emit(this.values);
    }
  }

  addNewRecord(): void {
    const duplicate = this.values.filter((existingValue: string) => existingValue === this.form.get('value').value);
    if (!duplicate.length) {
      this.values.unshift(this.form.get('value').value);
      this.form.get('value').setValue('');
      this.dataSource.data = this.values;
      this.formSubmitted.emit(this.values);
    }
  }

  editValue(value: string): void {
    this.formSubmitted.emit(this.values);
    const inputElement = this.el.nativeElement.children[0][0];
    inputElement.focus();
    this.form.get('value').setValue(value);
    this.values = this.values.filter((existingValue: string) => existingValue !== value);
    this.dataSource.data = this.values;
  }

  deleteValue(value: string): void {
    this.values = this.values.filter((existingValue: string) => existingValue !== value);
    this.dataSource.data = this.values;
    this.formSubmitted.emit(this.values);
  }

  writeValue(obj: any): void {
    this.values = obj || [];
    this.dataSource.data = this.values || [];
    if (this.onChange) {
      this.onChange(obj || []);
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
